import { render, staticRenderFns } from "./YieldDetail.vue?vue&type=template&id=8ed2646e"
import script from "./YieldDetail.vue?vue&type=script&lang=js"
export * from "./YieldDetail.vue?vue&type=script&lang=js"
import style0 from "./YieldDetail.vue?vue&type=style&index=0&id=8ed2646e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports